/* Boloween 2026 — Landingpage · Runde 04 (17.10.2026, nach Sabines Offer-Motiv)
   Plakate (Dosen fallen in die Pyramide, Spritzer, Fledermäuse, Parallaxe), Zahlen zählen hoch, „Süßes oder Wagyu?“,
   Warenkorb per Ajax, Countdown zum Halloween-Bestellschluss, Zeitstrahl,
   Abspann. Ohne JS steht die Seite vollständig (alle Knöpfe sind Links bzw.
   normale Warenkorb-Formulare). */
(function () {
  'use strict';
  var ruhig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fein = window.matchMedia && window.matchMedia('(pointer: fine)').matches;

  /* ---------- Einblenden beim Scrollen ---------- */
  function einblenden() {
    var el = document.querySelectorAll('.bwn [data-rv]');
    if (!('IntersectionObserver' in window)) { el.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
    el.forEach(function (e) { io.observe(e); });
  }

  /* ---------- Plakate (Runde 04): Start im Bild, Maus-Parallaxe der Fledermäuse ---------- */
  function plakate() {
    var ps = document.querySelectorAll('.bwn-plakat');
    if (!ps.length) return;
    var hero = document.querySelector('.bwn-plakat--hero');
    function messen() { if (hero) hero.style.setProperty('--bwn-oben', Math.min(220, Math.max(0, Math.round(hero.getBoundingClientRect().top + window.scrollY))) + 'px'); }
    messen(); window.addEventListener('resize', messen, { passive: true }); window.addEventListener('load', messen);
    function an(p) { p.classList.add('ist-an'); }
    if (ruhig || !('IntersectionObserver' in window)) { ps.forEach(an); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { an(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.2 });
    ps.forEach(function (p) { io.observe(p); });
    if (!fein) return;
    ps.forEach(function (p) {
      var mx = 0, my = 0, zx = 0, zy = 0, lauf = false;
      p.addEventListener('pointermove', function (ev) { var r = p.getBoundingClientRect(); zx = (ev.clientX - r.left) / r.width * 2 - 1; zy = (ev.clientY - r.top) / r.height * 2 - 1; stoss(); });
      p.addEventListener('pointerleave', function () { zx = 0; zy = 0; stoss(); });
      function stoss() { if (!lauf) { lauf = true; requestAnimationFrame(schritt); } }
      function schritt() {
        mx += (zx - mx) * .08; my += (zy - my) * .08;
        p.style.setProperty('--mx', mx.toFixed(4)); p.style.setProperty('--my', my.toFixed(4));
        if (Math.abs(zx - mx) > .002 || Math.abs(zy - my) > .002) requestAnimationFrame(schritt); else lauf = false;
      }
    });
  }

  /* ---------- Zahlen zählen hoch (Wagyu-Abschnitt) ---------- */
  function zaehlen() {
    var el = document.querySelectorAll('.bwn [data-zaehlen]');
    if (ruhig || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        var z = e.target, ziel = parseFloat(String(z.getAttribute('data-zaehlen')).replace(',', '.'));
        if (isNaN(ziel)) return;
        var start = null, dauer = 1400;
        function f(t) {
          if (!start) start = t;
          var k = Math.min(1, (t - start) / dauer), w = 1 - Math.pow(1 - k, 3);
          z.textContent = Math.round(ziel * w);
          if (k < 1) requestAnimationFrame(f); else z.textContent = z.getAttribute('data-zaehlen');
        }
        requestAnimationFrame(f);
      });
    }, { threshold: 0.6 });
    el.forEach(function (x) { io.observe(x); });
  }

  /* ---------- Weiches Scrollen zu Ankern + Ticket markieren ---------- */
  function anker() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('.bwn a[href^="#"]');
      if (!a) return;
      var id = a.getAttribute('href').slice(1), ziel = id && document.getElementById(id);
      if (!ziel) return;
      e.preventDefault();
      ziel.scrollIntoView({ behavior: ruhig ? 'auto' : 'smooth', block: ziel.classList.contains('bwn-ticket') ? 'center' : 'start' });
      if (ziel.classList.contains('bwn-ticket')) {
        ziel.classList.remove('ist-markiert'); void ziel.offsetWidth;
        setTimeout(function () { ziel.classList.add('ist-markiert'); }, ruhig ? 0 : 500);
      }
      if (history.replaceState) history.replaceState(null, '', '#' + id);
    });
  }

  /* ---------- Warenkorb per Ajax (Formular bleibt Rückfall) ---------- */
  function kauf() {
    document.querySelectorAll('.bwn form[data-kauf]').forEach(function (f) {
      f.addEventListener('submit', function (e) {
        if (!window.fetch) return;
        e.preventDefault();
        var k = f.querySelector('button'); k.classList.add('ist-laedt');
        var id = f.querySelector('[name="id"]').value;
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: +id, quantity: 1 }] })
        }).then(function (r) { if (!r.ok) throw r; return r.json(); })
          .then(function () { window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart'; })
          .catch(function () { f.submit(); });
      });
    });
  }

  /* ---------- Countdown + Zeitstrahl ---------- */
  function fahrplan() {
    document.querySelectorAll('.bwn-fahrplan').forEach(function (s) {
      var schluss = Date.parse(s.getAttribute('data-schluss')), ende = Date.parse(s.getAttribute('data-ende'));
      var uhr = s.querySelector('.bwn-uhr'), titel = s.querySelector('[data-uhr-titel]');
      var felder = { d: s.querySelector('[data-d]'), h: s.querySelector('[data-h]'), m: s.querySelector('[data-m]'), s: s.querySelector('[data-s]') };
      var alt = {};
      function setzen(el, k, wert) {
        if (!el) return;
        var txt = wert < 10 ? '0' + wert : '' + wert;
        if (alt[k] === txt) return; alt[k] = txt;
        el.innerHTML = '<i class="' + (ruhig ? '' : 'neu') + '">' + txt + '</i>';
      }
      function tick() {
        var jetzt = Date.now(), ziel, satz;
        if (jetzt < schluss) { ziel = schluss; satz = s.getAttribute('data-vor'); }
        else if (jetzt < ende) { ziel = ende; satz = s.getAttribute('data-nach'); }
        else { if (uhr) uhr.hidden = true; if (titel) titel.textContent = s.getAttribute('data-vorbei'); return; }
        if (titel && titel.textContent !== satz) titel.textContent = satz;
        var r = Math.max(0, Math.floor((ziel - jetzt) / 1000));
        setzen(felder.d, 'd', Math.floor(r / 86400)); setzen(felder.h, 'h', Math.floor(r % 86400 / 3600));
        setzen(felder.m, 'm', Math.floor(r % 3600 / 60)); setzen(felder.s, 's', r % 60);
        setTimeout(tick, 1000 - (Date.now() % 1000));
      }
      if (uhr && schluss && ende) tick();

      // Zeitstrahl: vergangene Halte rot, heutiger pulsiert, Linie bis heute
      var halte = [].slice.call(s.querySelectorAll('.bwn-halt')), heute = new Date(), letzter = -1;
      var tag = function (d) { return d.getFullYear() * 10000 + (d.getMonth() + 1) * 100 + d.getDate(); };
      halte.forEach(function (hlt, i) {
        var d = new Date(hlt.getAttribute('data-tag') + 'T12:00:00');
        if (isNaN(d)) return;
        if (tag(d) < tag(heute)) { hlt.classList.add('ist-vorbei'); letzter = i; }
        else if (tag(d) === tag(heute)) { hlt.classList.add('ist-heute'); letzter = i; }
      });
      var strahl = s.querySelector('.bwn-strahl');
      if (strahl && halte.length > 1) {
        var f = letzter < 0 ? 0.04 : Math.min(1, letzter / (halte.length - 1) + (letzter < halte.length - 1 ? 0.06 : 0));
        strahl.style.setProperty('--fortschritt', f.toFixed(3));
      }
    });
  }

  /* ---------- Abspann rollt nur im Bild ---------- */
  function abspann() {
    var r = document.querySelectorAll('.bwn-rolle');
    if (ruhig || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { e.target.classList.toggle('laeuft', e.isIntersecting); });
    }, { threshold: 0.2 });
    r.forEach(function (x) { io.observe(x); });
  }

  function start() { einblenden(); plakate(); zaehlen(); anker(); kauf(); fahrplan(); abspann(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
